import { useCallback } from 'react';
import { useFavorites } from '@/hooks/useFavorites';
import { FavoriteStarButton } from './FavoriteStarButton';

type ConnectorFavoriteButtonProps = {
  connectorId: string;
  connectorName: string;
};

export const ConnectorFavoriteButton = ({
  connectorId,
  connectorName,
}: ConnectorFavoriteButtonProps) => {
  const { isFavorite, toggle } = useFavorites();
  const isFavorited = isFavorite(connectorId);

  const handleToggle = useCallback(() => toggle(connectorId), [connectorId, toggle]);

  const label = isFavorited
    ? `Remove ${connectorName} from favorites`
    : `Add ${connectorName} to favorites`;

  return (
    <FavoriteStarButton
      isFavorited={isFavorited}
      onToggle={handleToggle}
      label={label}
      title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
    />
  );
};

export default ConnectorFavoriteButton;
